import Vue from 'vue'
import 'vant/lib/index.css'

// 按需引用vant,减小代码包体积
import {
  NavBar,
  Grid, GridItem,
  Row, Col,
  Button,
  Swipe, SwipeItem,
  Icon,
  Cell, CellGroup,
  Tab, Tabs,
  Field,
  Image,
  Progress,
  Checkbox, CheckboxGroup,
  RadioGroup, Radio,
  Collapse, CollapseItem,
  Switch, SwitchCell,
  Picker,
  Popup,
  Dialog,
  Slider,
  Toast,
  Search
} from 'vant'

// 导航栏
Vue.use(NavBar)
// Grid 宫格
Vue.use(Grid).use(GridItem)
// layout
Vue.use(Row).use(Col)
// 按钮
Vue.use(Button)
// 轮播
Vue.use(Swipe).use(SwipeItem)
// 图标
Vue.use(Icon)
// 单元格
Vue.use(Cell).use(CellGroup)
// 标签页
Vue.use(Tab).use(Tabs)
// 输入框
Vue.use(Field)
// 进度条
Vue.use(Progress)
// 复选框
Vue.use(Checkbox).use(CheckboxGroup)
// 单选框
Vue.use(Radio).use(RadioGroup)
// 折叠面板
Vue.use(Collapse).use(CollapseItem)
// 开关
Vue.use(Switch)
Vue.use(SwitchCell)
// 选择器
Vue.use(Picker)
// 弹出层
Vue.use(Popup)
// 弹出框
Vue.use(Dialog)
// 图片
Vue.use(Image)
// 滑块
Vue.use(Slider)
// 轻提示
Vue.use(Toast)
// 搜索
Vue.use(Search)
